import React from 'react';
import Footer from '../../../components/MainComponents/Footer';
import { aboutBanners, bannerServiceImage, doctorHomeImages } from '../../../config';
import Header from '../../../components/MainComponents/Header';
import ContactHeader from '../../../components/MainComponents/ContactHeader';

const teamMember =  {
    id: 1,
    name: 'Dr. Aditya Shashtri',
    specialization: 'Physiotherapist',
    degree: 'M.Sc (Physiotherapist)',
    experience: '18 years of experience',
    biography: 'Dr. Aditya Shashtri has over 18 years of experience in the field of physiotherapy, specializing in knee and hip pain treatment, ligament and sports surgeries, and rehabilitation. He has worked with various hospitals and clinics, helping patients recover from severe injuries and post-surgery recovery. Dr. Shashtri believes in a holistic approach to patient care, combining modern medical practices with alternative therapies for the best patient outcomes.',
    expertise: [
      'Knee Pain Treatment',
      'Hip Pain Rehabilitation',
      'Ligament and Sports Surgeries',
      'Post-Surgery Recovery',
    ],
    quote: 'Recovery is not a race. It’s a journey of regaining strength, mobility, and independence. I am committed to being by your side throughout the process.',
    testimonials: [
      {
        text: 'Dr. Shashtri helped me recover from a severe knee injury. His treatment plan was customized for me, and I couldn’t have asked for a better physiotherapist!',
        clientName: 'John Doe',
        clientInfo: 'Recovered from Knee Surgery',
      },
      {
        text: 'Thanks to Dr. Shashtri’s expertise, I was able to recover from a ligament tear much faster than expected. I highly recommend him!',
        clientName: 'Jane Smith',
        clientInfo: 'Sports Injury',
      },
      {
        text: 'Thanks to Dr. Shashtri’s expertise, I was able to recover from a ligament tear much faster than expected. I highly recommend him!',
        clientName: 'Jane Smith',
        clientInfo: 'Sports Injury',
      },
    ],
    image: doctorHomeImages.doctor4,
    backgroundImage: aboutBanners.bannerOne,
  }

const TeamMemberDetail = () => {
  

  return (
    <div>
      {/* Header Section */}
      <ContactHeader/>
      <Header/>
      <section className="relative bg-gradient-to-t from-gray-900 to-gray-800 text-white text-center py-32">
        <div className="absolute inset-0">
          <img
            src={teamMember.backgroundImage}
            alt={teamMember.name}
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="relative z-10">
          <h1 className="text-5xl font-extrabold lg:text-6xl">{teamMember.name}</h1>
          <p className="text-2xl mt-4">{teamMember.specialization}</p>
        </div>
      </section>

      {/* Biography Section */}
      <section className="container mx-auto py-12 px-6 lg:px-16 flex flex-col lg:flex-row items-start justify-between space-y-8 lg:space-y-0">
        {/* Profile Image */}
        <div className="lg:w-1/3">
          <img
            src={teamMember.image}
            alt={teamMember.name}
            className="rounded-lg shadow-xl w-full lg:w-3/4 mx-auto"
          />
        </div>

        {/* Profile Details */}
        <div className="lg:w-2/3">
          <h2 className="text-4xl font-bold mb-6">About {teamMember.name}</h2>
          <p className="text-lg text-gray-700 mb-6">{teamMember.biography}</p>

          {/* Areas of Expertise */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-2xl font-bold mb-4">Areas of Expertise</h3>
            <ul className="list-disc list-inside text-lg text-gray-600">
              {teamMember.expertise.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Personal Quote */}
          <div className="bg-primary text-white p-6 rounded-lg shadow-lg">
            <blockquote className="italic text-lg">{teamMember.quote}</blockquote>
            <cite className="block text-right mt-4">{teamMember.name}</cite>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gray-100 py-16">
        <div className="container mx-auto text-center">
          <h3 className="text-3xl font-bold mb-12 lg:text-4xl">Testimonials about <br/>{teamMember.name}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 m-4 lg:grid-cols-3 gap-8 lg:m-0">
            {teamMember.testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-xl">
                <p className="text-lg text-gray-700 mb-4">"{testimonial.text}"</p>
                <h4 className="text-xl font-semibold">{testimonial.clientName}</h4>
                <p className="text-gray-500">{testimonial.clientInfo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TeamMemberDetail;
